// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1LKRW","approved":"Status_approved__2wnro","rejected":"Status_rejected__3nXOF","expired":"Status_expired__2h_he","label":"Status_label__1gupz"};